import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import axios from "axios";

// Maintenance Mode - set to true to enable
const MAINTENANCE_MODE = false;

// Pages
import MaintenancePage from "@/pages/MaintenancePage";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Cars from "@/pages/Cars";
import CarDetail from "@/pages/CarDetail";
import Contact from "@/pages/Contact";
import Gallery from "@/pages/Gallery";
import Reviews from "@/pages/Reviews";
import Products from "@/pages/Products";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

// Components
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  useEffect(() => {
    // Seed database on first load
    const seedData = async () => {
      try {
        await axios.post(`${API}/seed`);
      } catch (e) {
        console.log("Seed already done or error:", e.message);
      }
    };
    seedData();
  }, []);

  // Maintenance mode - show maintenance page except for admin
  if (MAINTENANCE_MODE && !window.location.pathname.startsWith('/admin')) {
    return <MaintenancePage />;
  }

  return (
    <div className="App min-h-screen bg-white">
      <BrowserRouter>
        <Header />
        <main className="pt-28">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/a-propos" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/voitures" element={<Cars />} />
            <Route path="/voitures/:id" element={<CarDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/galerie" element={<Gallery />} />
            <Route path="/avis" element={<Reviews />} />
            <Route path="/produits" element={<Products />} />
            <Route path="/paiement-succes" element={<PaymentSuccess />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
